import HorizontalLineChart from './HorizontalLineChart';

export default HorizontalLineChart;
